
import { defineComponent, computed, ref } from 'vue'
import { SelectTypes } from 'ant-design-vue/es/select'
import { InfoCircleFilled, PlusOutlined } from '@ant-design/icons-vue'
import MFeedCompute from '@/components/MFeedCompute.vue'

export default defineComponent({
  name: 'Home',
  components: { MFeedCompute, InfoCircleFilled, PlusOutlined },
  setup() {
    const columns = [
      {
        title: '各階段需求',
        dataIndex: 'title',
        key: 'title'
      },
      {
        title: 'DER 乘數',
        dataIndex: 'der',
        key: 'der'
      }
    ]
    const dataSource = [
      {
        key: '1',
        title: '幼貓(4個月以下)',
        der: 'RER X 2.5(最少)~更多'
      },
      {
        key: '2',
        title: '幼貓(4個月至1歲)',
        der: 'RER X 2 ~ 更多'
      },
      {
        key: '3',
        title: '已結紮成貓 (1~7歲)',
        der: 'RER X 1.2~1.4'
      },
      {
        key: '4',
        title: '未結紮成貓 (1~7歲)',
        der: 'RER X 1.4~1.6'
      },
      {
        key: '5',
        title: '中年成貓(7~11歲)',
        der: 'RER X 1.1~1.4'
      },
      {
        key: '6',
        title: '熟齡成貓(11歲以上)',
        der: 'RER X 1.1~1.6'
      },
      {
        key: '7',
        title: '不活躍/肥胖成貓',
        der: 'RER(以理想體重計算)X 0.8~1.0'
      },
      {
        key: '8',
        title: '久坐成貓 / 生病成貓',
        der: 'RER X 1'
      },
      {
        key: '9',
        title: '過瘦成貓',
        der: 'RER(以理想體重計算)X 1.2~1.8'
      },
      {
        key: '10',
        title: '懷孕中母貓',
        der: 'RER X 1.6~2.0'
      },
      {
        key: '11',
        title: '哺乳中母貓',
        der: 'RER X 2.0(最少)~更多'
      }
    ]
    const modalVisible = ref(false)
    const feedComputeLimit = 5
    const feedCompute = ref([{ index: Date.now(), visable: true }])
    const weight = ref(0)
    const derActivekey = ref(null)
    const derOptions = ref<SelectTypes['options']>([
      {
        label: '幼貓(4個月以下)',
        value: '1'
      },
      {
        label: '幼貓(4個月至1歲)',
        value: '2'
      },
      {
        label: '已結紮成貓 (1~7歲)',
        value: '3'
      },
      {
        label: '未結紮成貓 (1~7歲)',
        value: '4'
      },
      {
        label: '中年成貓(7~11歲)',
        value: '5'
      },
      {
        label: '熟齡成貓(11歲以上)',
        value: '6'
      },
      {
        label: '不活躍/肥胖成貓',
        value: '7'
      },
      {
        label: '久坐成貓 / 生病成貓',
        value: '8'
      },
      {
        label: '過瘦成貓',
        value: '9'
      },
      {
        label: '懷孕中母貓',
        value: '10'
      },
      {
        label: '哺乳中母貓',
        value: '11'
      }
    ])
    const DER = ref([0])
    const RER = computed(() => {
      if (typeof weight.value !== 'number') return 0
      if (!weight.value) return 0
      if (weight.value <= 0) return 0
      const wBase = Math.round(Math.pow(weight.value, 3))
      return Math.round(70 * Math.sqrt(Math.sqrt(wBase)))
    })
    const result = computed(() => {
      const der = DER.value
      const rer = RER.value
      if (!rer || rer <= 0) return [0]
      if (!der?.[0] || der?.[0] <= 0 || der.length === 0) return [0]
      if (der.length === 2) {
        let limitResult = 0
        let maxResult: any = 0
        if (der?.[0]) limitResult = der[0]
        if (der?.[1]) maxResult = der[1]
        if (maxResult === '*')
          return [Math.round(rer * limitResult), '*']
        else if (typeof maxResult === 'number')
          return [Math.round(rer * limitResult), Math.round(rer * maxResult)]
        else return [0]
      }
      if (der.length === 1)
        return [Math.round(rer * der[0])]
      return [0]
    })
    type derMapType = {
      [key: string]: Array<any>
    }
    const handleDerChange = (key:string) => {
      const derMap: derMapType = {
        1: [2.5, '*'],
        2: [2, '*'],
        3: [1.2, 1.4],
        4: [1.4, 1.6],
        5: [1.1, 1.4],
        6: [1.1, 1.6],
        7: [0.8, 1],
        8: [1],
        9: [1.2, 1.8],
        10: [1.6, 2],
        11: [2, '*']
      }
      DER.value = derMap[key]
    }
    const disabledAdd = computed(() => {
      const totalVisable = feedCompute.value.filter(item => item.visable === true)
      if (totalVisable.length === feedComputeLimit) return true
      else return false
    })
    const handleAdd = () => {
      if (!disabledAdd.value)
        feedCompute.value.push({ index: Date.now(), visable: true })
    }
    const handleComputeClose = (item: any) => {
      feedCompute.value = feedCompute.value.map(computeItem => {
        if (computeItem.index === item.index)
          computeItem.visable = false
        return computeItem
      })
    }
    const handleFocus = (e: any) => {
      e.target.select()
    }
    return {
      columns,
      dataSource,
      modalVisible,
      weight,
      derActivekey,
      derOptions,
      result,
      RER,
      feedCompute,
      feedComputeLimit,
      disabledAdd,
      handleFocus,
      handleAdd,
      handleDerChange,
      handleComputeClose
    }
  }
})
